module.exports = __webpack_public_path__ + "img/img2.b1da7995.svg";